'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { Icon } from '@/components/ui/icon';
import {
  Alert01IconSolid,
  CancelCircleIconSolid,
  CheckmarkCircle02IconSolid,
  InformationCircleIconSolid,
  Loading03Icon,
} from '@/components/ui/icon/glyphs';

const Toaster = (props: ToasterProps): React.JSX.Element => {
  const { theme: _themeProp, ...restProps } = props;
  const { theme } = useTheme();
  const resolvedTheme: ToasterProps['theme'] =
    theme === 'light' || theme === 'dark' ? theme : 'system';

  const toasterProps: ToasterProps = {
    ...restProps,
    theme: resolvedTheme,
  };

  return (
    <Sonner
      {...toasterProps}
      className="toaster group"
      icons={{
        success: <Icon icon={CheckmarkCircle02IconSolid} className="size-4" />,
        info: <Icon icon={InformationCircleIconSolid} className="size-4" />,
        warning: <Icon icon={Alert01IconSolid} className="size-4" />,
        error: <Icon icon={CancelCircleIconSolid} className="size-4" />,
        loading: (
          <Icon icon={Loading03Icon} className="size-4 animate-spin motion-reduce:animate-none" />
        ),
      }}
      style={
        {
          '--normal-bg': 'var(--surface-floating)',
          '--normal-text': 'var(--foreground-primary)',
          '--normal-border': 'var(--border-primary)',
          '--border-radius': 'var(--radius-overlay)',
          flexDirection: 'column-reverse',
        } as React.CSSProperties
      }
    />
  );
};

export { Toaster };
